import application_settings from '../applicationSettings';
import Event from './Event';
import $ from 'jquery';

class GetSocialProviders extends Event {
    eventName = 'oms_getSocialProviders';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get Specific Products
     * 
     * @param (json) data.attributes  - given attributes filters
     * @return void
     *  
     */
    eventFunction(data) {
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        // request data
        data.endPoint = application_settings.endPoints.getSocialProviders;
        data.multi_call_key = (data.multi_call_key) ? data.multi_call_key : 'social_providers';
        
        // send request
        this.sendRequest(data, function (response) {
            if (response) {
                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {
                    'action' : action, 
                    'request_id' : requestId, 
                });
            }
        });

    }

    /**
     * @override fire success event
     * 
     * @param {any} data data to pass for the event
     */
    /**
     * 
     * @param {*} data data to pass for the event
     * @param {*} options 
     */
    // onSuccessEvent(data, action = '', dataType = '', request_id = null) {
    onSuccessEvent(data, options = []) {
        try {

            let response = {
                // "action": (action) ? action : null
                "action": (options['action']) ? options['action'] : null,
                "start": options['start']
            };

            $.extend(response, data);

            let requestId = (options['request_id']) ? options['request_id'] : '';
            this.dispatch(this.eventName + 'Success' + requestId, { "result": response });

        } catch (error) {
            console.log(error);
        }
    }
}

export default GetSocialProviders;